import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiCircularProgress from '@material-ui/core/CircularProgress';
// Internal
import withLocalTheme from './hocs/WithLocalTheme';

const AppLoader = withLocalTheme(({ size, disableShrink }) => {
  // Components props
  const loaderProps = { size, disableShrink };

  return (
    <MuiCircularProgress color="primary" {...loaderProps} />
  );
});

AppLoader.propTypes = {
  size: PropTypes.number,
  disableShrink: PropTypes.bool,
};

AppLoader.defaultProps = {
  size: 40,
  disableShrink: false,
};

export default React.memo(AppLoader);



// WEBPACK FOOTER //
// ./components/core/AppLoader.js